export class JobClassifierApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns JobClassificationResponse
     * @throws ApiError
     */
    classifyJob({ title, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/classifier/job',
            query: {
                'title': title,
            },
        });
    }
    /**
     * @returns JobCategory
     * @throws ApiError
     */
    createCategory({ name, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/classifier/job/category',
            query: {
                'name': name,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    deleteCategory({ name, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/classifier/job/category',
            query: {
                'name': name,
            },
        });
    }
    /**
     * @returns BenchmarkReport
     * @throws ApiError
     */
    runBenchmark() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/classifier/job/benchmark',
        });
    }
}
